<template>
  <g v-if="svgWidth">
    <text v-if="svgWidth > svgSmallSizeBreakpoint" :x="(svgWidth / 2)" :y="svgHeight / 2" text-anchor="middle" fill="#8e8e8e" font-size="14pt">{{ `${ $t('no-fiber-count-hint.line1') } ${ $t('no-fiber-count-hint.line2') }` }}</text>
    <text v-if="svgWidth <= svgSmallSizeBreakpoint" :x="(svgWidth / 2)" y="30" text-anchor="middle" fill="#8e8e8e" font-size="9pt">{{ $t('no-fiber-count-hint.line1') }}</text>
    <text v-if="svgWidth <= svgSmallSizeBreakpoint" :x="(svgWidth / 2)" y="45" text-anchor="middle" fill="#8e8e8e" font-size="9pt">{{ $t('no-fiber-count-hint.line2') }}</text>
  </g>
</template>

<script>
export default {
  props: ['svgWidth', 'svgSmallSizeBreakpoint', 'svgHeight']
}
</script>